import React, { useEffect, useState } from "react";
import axios from "axios";

const AdminPanel = () => {
  const [otps, setOtps] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchOtps = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await axios.get("/api/otps", {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
        if (response.data.success) {
          setOtps(response.data.otps);
        } else {
          setError("Failed to fetch OTPs.");
        }
      } catch (err) {
        console.error("Error fetching OTPs:", err);
        setError("An error occurred while fetching OTPs.");
      } finally {
        setLoading(false);
      }
    };

    fetchOtps();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div className="error-message">{error}</div>;
  }

  return (
    <div className="admin-panel">
      <h2>Admin Panel - OTP Records</h2>
      <table className="otp-table">
        <thead>
          <tr>
            <th>Phone Number</th>
            <th>OTP</th>
            <th>Expires At</th>
          </tr>
        </thead>
        <tbody>
          {otps.map((otp, index) => (
            <tr key={index}>
              <td>{otp.phoneNumber}</td>
              <td>{otp.otp}</td>
              <td>{new Date(otp.expiresAt).toLocaleString()}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AdminPanel;